import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal"]
    static values = {
        visits: { type: Number, default: 0 },
        isAuthenticated: { type: Boolean, default: false }
    }

    connect() {
        if (document.documentElement.hasAttribute('data-turbo-native-app')) return

        this.visits = parseInt(Cookies.get('visits') || 0)

        // Check authentication status from meta tag
        const authMeta = document.querySelector('meta[name="turbo:authenticated"]')
        this.isAuthenticated = authMeta ? authMeta.content === 'true' : false

        this.hasSeenToday = Cookies.get('app_promo_shown_today')
        this.lastScrollY = window.scrollY
        this.modalShown = false

        this.handleScroll = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.handleScroll)
    }

    disconnect() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    show() {
        this.modalTarget.classList.remove('pointer-events-none')
        requestAnimationFrame(() => {
            this.modalTarget.classList.remove('opacity-0')
        })
        this.modalShown = true

        Cookies.set('app_promo_shown_today', 'true', { expires: 1 }) // Set cookie to expire in 24 hours

        // Update theme color to indigo-50
        let themeMeta = document.querySelector('meta[name="theme-color"]')
        if (!themeMeta) {
            themeMeta = document.createElement('meta')
            themeMeta.name = 'theme-color'
            document.head.appendChild(themeMeta)
        }
        themeMeta.content = '#E0E7FF' // indigo-100 color
    }

    hide() {
        this.modalTarget.classList.add('opacity-0')
        this.modalTarget.classList.add('pointer-events-none')

        // Reset theme color to white
        let themeMeta = document.querySelector('meta[name="theme-color"]')
        if (themeMeta) {
            themeMeta.content = '#ffffff'
        }
    }

    handleScroll() {
        // Don't show if already shown today for authenticated users
        if (this.isAuthenticated && this.hasSeenToday) return

        // Don't show if not enough visits
        if (this.visits < 2) return

        // Don't show if already shown in this session
        if (this.modalShown) return

        const currentScrollY = window.scrollY
        const isScrollingDown = currentScrollY > this.lastScrollY

        // Only show if scrolling down and past viewport height
        if (isScrollingDown && currentScrollY > window.innerHeight) {
            this.show()
        }

        this.lastScrollY = currentScrollY
    }
}
